require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-indiana-latino-institute.json") })
        }
      }, "path---articles-tags-indiana-latino-institute");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-indiana-latino-institute!./.cache/json/articles-tags-indiana-latino-institute.json
// module id = 1848
// module chunks = 231608221292675